import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { CallResponse, HttpResponse } from "@/types";

export function useGetCalls({
  enabled = true,
  talentId,
}: {
  enabled?: boolean;
  talentId: number | null;
}) {
  return useQuery({
    queryKey: ["calls", talentId],
    enabled,
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams({ talentId });

      if (queryParams.toString() === "") return [];

      const path = `calls?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        CallResponse[],
        HttpResponse<CallResponse[]>
      >(path);
      return res.data;
    },
  });
}
